import React from 'react'
import FallbackLogo from '../components/FallbackLogo'

export default function BackgroundCompanyPage() {
  return <FallbackLogo />
}
